<div class="dialog-header">
    <h2 mat-dialog-title>{{ "dssAdminLibFlightZoneManagement.editSuggestedRestrictionTypeDialog.dialogHeader" | transloco }}</h2>
    <button type="button" class="button-icon" [matDialogClose]="false">
        <dtm-ui-icon name="close"></dtm-ui-icon>
    </button>
</div>
<div mat-dialog-content>
    <dtm-ui-info-message *ngIf="data.isCustomDesignatorSet" type="warning">{{
        "dssAdminLibFlightZoneManagement.editSuggestedRestrictionTypeDialog.dialogWarnMessage" | transloco
    }}</dtm-ui-info-message>

    <dtm-ui-select-field [formControl]="restrictionTypeControl" id="restrictionTypeControl">
        <label for="restrictionTypeControl">
            {{ "dssAdminLibFlightZoneManagement.editSuggestedRestrictionTypeDialog.selectRestrictionTypeLabel" | transloco }}
        </label>

        <dtm-ui-select-option *ngFor="let restrictionType of data.availableRestrictionTypes" [value]="restrictionType">
            {{ "dssSharedLibFlightZone.applicationSummary.designatorTypeValueLabel" | transloco : { value: restrictionType } }}
        </dtm-ui-select-option>

        <div class="field-error" *dtmUiFieldHasError="restrictionTypeControl; name: 'required'">
            {{ "dssAdminLibFlightZoneManagement.requiredFieldErrorHint" | transloco }}
        </div>
    </dtm-ui-select-field>
</div>
<div mat-dialog-actions align="end">
    <button type="button" class="button-secondary" cdkFocusInitial [mat-dialog-close]="null">
        {{ "dssAdminLibFlightZoneManagement.editSuggestedRestrictionTypeDialog.cancelButtonLabel" | transloco }}
    </button>
    <button type="button" class="button-primary" (click)="onConfirmClick()">
        {{ "dssAdminLibFlightZoneManagement.editSuggestedRestrictionTypeDialog.confirmButtonLabel" | transloco }}
    </button>
</div>
